import React from 'react';
import '../App.css';

const About = ({ onNavigate }) => {
  return (
    <div className='app'>
      <div className="container2">
        <h1 className="hoverable about-heading">About Me</h1>
        <div className="links3">
          <a
            href="/"
            className="hoverable link-about"
            onClick={(e) => {
              e.preventDefault();
              onNavigate('/');
            }}
          >
            Home
          </a>
          <a
            href="/projects"
            className="hoverable link-projects"
            onClick={(e) => {
              e.preventDefault();
              onNavigate('/projects');
            }}
          >
            Projects
          </a>
          <a
            href="/contact"
            className="hoverable link-projects"
            onClick={(e) => {
              e.preventDefault();
              onNavigate('/contact');
            }}
          >
            Contact
          </a>
        </div>
        <p className="hoverable about-details">

          I started game development when I was 14, in 8th grade. I didn't know how to code but managed to make a few games by watching YouTube tutorials.<br />Then I felt a need to learn programming. In 9th grade, I learned Python, my first programming language. I was in love with programming.<br /><br />

          I made an NFT Collection named "HappyCups".<br/>
          I explored web development and built several websites during 10th and 11th grade.
          Then, I had an idea to create a spaced repetition web app to help me study effectively. After making the web app, I realized that constantly opening a URL wasn't very convenient.<br /><br />

          That's when I decided to learn app development and made a mobile version of that app, along with a few others in my 11th and 12th grades.<br /><br />

          I loved creating something of my own, and that passion has driven me ever since.
        </p>

      </div>

    </div>
  );
}

export default About;
